import { render, staticRenderFns } from "./PropTile.vue?vue&type=template&id=bfb54ec6&scoped=true"
import script from "./PropTile.vue?vue&type=script&lang=js"
export * from "./PropTile.vue?vue&type=script&lang=js"
import style0 from "./PropTile.vue?vue&type=style&index=0&id=bfb54ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb54ec6",
  null
  
)

export default component.exports